import * as Yup from 'yup';
import { TargetTypesEnum } from '../../models/target-type';
import { CLEVERTAP_CONFIG } from './CleverTap/config';
import { FRESHDESK_CONFIG } from './Freshdesk/config';
import { GOOGLE_SHEETS_CONFIG } from './GoogleSheets/config';
import { KLAVIYO_CONFIG } from './Klaviyo/config';
import { MARKETO_CONFIG } from './Marketo/config';
import { MIXPANEL_CONFIG } from './Mixpanel/config';
import { ZENDESK_CONFIG } from './Zendesk/config';

export const ConfigByType = {
  [TargetTypesEnum.GOOGLE_SHEETS]: GOOGLE_SHEETS_CONFIG,
  [TargetTypesEnum.ZENDESK]: ZENDESK_CONFIG,
  [TargetTypesEnum.MARKETO]: MARKETO_CONFIG,
  [TargetTypesEnum.KLAVIYO]: KLAVIYO_CONFIG,
  [TargetTypesEnum.MIXPANEL]: MIXPANEL_CONFIG,
  [TargetTypesEnum.FRESHDESK]: FRESHDESK_CONFIG,
  [TargetTypesEnum.CLEVERTAP]: CLEVERTAP_CONFIG,

  getValidationSchema: (targetTypeIdentifier: TargetTypesEnum) => {
    let validationSchema = ConfigByType[targetTypeIdentifier].validationSchema || Yup.object({});

    validationSchema = validationSchema.concat(
      Yup.object({
        targetName: Yup.string().trim().required()
      })
    );

    return validationSchema;
  },

  getErroredFieldNames: (type, fieldNames) => {
    let erroredFieldNames = fieldNames;
    const allFieldNames = ConfigByType.getFieldNamesMapping(type);

    if (allFieldNames) {
      erroredFieldNames = fieldNames.map(field => allFieldNames[field] || field);
    }

    return erroredFieldNames;
  },

  getFieldNamesMapping: type => ({
    ...ConfigByType[type].fieldNameMapping,
    targetName: 'target-name'
  })
};
